<!--
 * @FileDescription: 新增编辑菜单（注释描述）
 * @Author: ryb（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: ryb（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="new-add-menu">
    <a-drawer :title="title" placement="right" :closable="false" @close="onClose" :visible="visible" :width="600">
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" @submit="handleSubmit">
        <a-form-item label="菜单类型：">
          <a-radio-group name="radioGroup" v-model="menuData.menuType" @change="changeMenuType">
            <a-radio :value="'0'">一级菜单</a-radio>
            <a-radio :value="'1'">子菜单</a-radio>
            <a-radio :value="'2'">按钮</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :label="menuData.menuType=='2'? '按钮名称' :'菜单名称'">
          <a-input :placeholder="menuData.menuType=='2'? '请输入按钮名称' :'请输入菜单名称'"
            v-decorator="['name', { rules: [{ required: true, message: '请输入菜单名称' }] }]" />
        </a-form-item>
        <a-form-item v-show="menuData.menuType=='2'" label="按钮标识">
          <a-input placeholder="请输入按钮标识" v-model="menuData.buttonLabel" />
        </a-form-item>
        <a-form-item v-show="menuData.menuType!='0'" label="上级菜单">
          <a-tree-select style="width:100%" :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
            placeholder="请选择父级菜单" @select="selectTree" v-model="menuValue">
            <a-tree-select-node v-for="(oneitem) in treeData" :value="oneitem.id" :title="oneitem.name"
              :key="oneitem.id">
              <a-tree-select-node v-for="(twoitem) in oneitem.children" :value="twoitem.id" :title="twoitem.name"
                :key="twoitem.id">
                <a-tree-select-node v-for="(threeitem) in twoitem.children" :value="threeitem.id"
                  :title="threeitem.name" :key="threeitem.id" />
              </a-tree-select-node>
            </a-tree-select-node>
          </a-tree-select>
        </a-form-item>
        <a-form-item v-if="menuData.menuType!='2'" label="菜单路径">
          <a-input placeholder="请输入菜单路径" v-decorator="['url', { rules: [{ required: true, message: '请输入菜单路径' }] }]" />
        </a-form-item>
        <a-form-item v-if="menuData.menuType!='2'" label="前端组件">
          <a-input placeholder="请输入前端组件"
            v-decorator="['component', { rules: [{ required: true, message: '请输入前端组件' }] }]" />
        </a-form-item>
        <a-form-item v-show="menuData.menuType!='2'" label="菜单图标">
          <a-input placeholder="请输入菜单图标" v-decorator="['icon', {}]" />
        </a-form-item>
        <a-form-item :label="menuData.menuType=='2'? '按钮排序' :'菜单排序'">
          <a-input-number id="inputNumber" v-model="menuData.sortNo" />
        </a-form-item>
        <a-form-item label="是否是路由菜单" v-show="menuData.menuType=='1'">
          <a-radio-group name="radioGroup" v-model="menuData.routeFlag" @change="changeIsMenu">
            <a-radio :value="'1'">是</a-radio>
            <a-radio :value="'0'">否</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="权限类型">
          <a-radio-group name="radioGroup" v-model="menuData.permissionType">
            <a-radio :value="'1'">erp权限</a-radio>
            <a-radio :value="'2'">云店权限</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="移动端菜单图标">
          <a-input placeholder="菜单图标" v-model="menuData.appIcon" />
        </a-form-item>
        <a-form-item label="移动端菜单路由">
          <a-input placeholder="菜单路由" v-model="menuData.appRouter" />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
          <a-button type="primary" html-type="submit">
            确定
          </a-button>
        </a-form-item>
      </a-form>
    </a-drawer>
  </div>
</template>
<script>
import pick from "lodash.pick";
import {
  addPermission,
  findPermissionAll,
  updatePermission,
} from "@/utils/api";
export default {
  data() {
    return {
      title: "新增",
      visible: false, // 显示隐藏
      treeData: [], // 所有菜单列表
      menuData: {
        url: "",
        icon: "",
        component: "",
        parentId: "",
        sortNo: "",
        menuType: "", // 添加或编辑菜单类型
        routeFlag: "", // 是否是路由菜单  默认为1,
        leafFlag: "",
        buttonLabel: "",
      },
      menuValue: [],
      isEdit: false,
      form: this.$form.createForm(this),
    };
  },
  methods: {
    // 初始化数据（方法描述）
    init() {
      this.menuData = {
        url: "",
        icon: "",
        component: "",
        parentId: "",
        routeFlag: "",
        name: "",
        menuType: "",
        leafFlag: "",
      };
    },
    // 打开添加或编辑框（方法描述）
    show(type, dataSource, data) {
      console.log(data);
      this.form = this.$form.createForm(this);
      if (type == 1) {
        this.visible = true;
        this.isEdit = false;
        this.treeData = dataSource;
        this.menuData.routeFlag = "1";
        this.menuData.menuType = "0";
        this.menuData.component = "layout/RouteView";
        this.setMenuData();
      } else if (type == 2) {
        this.menuValue = [];
        this.visible = true;
        this.isEdit = true;
        this.menuData = data;
        this.menuValue.push(data.parentId);
        this.treeData = dataSource;
        this.setMenuData();
      }
    },
    // 赋值数据（方法描述）
    setMenuData() {
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.menuData, "url", "component", "name", "icon")
        );
      });
    },
    // 隐藏左侧弹出框
    onClose() {
      this.init();
      this.visible = false;
    },
    // 选择添加或编辑菜单类型（方法描述）
    changeMenuType(val) {
      this.menuData.menuType = val.target.value;
    },
    // 选择上级菜单（方法描述）
    selectTree(a, b, c) {
      this.menuData.parentId = c.selectedNodes[0].key;
    },
    // 选择是否是路由菜单
    changeIsMenu(val) {
      this.menuData.routeFlag = val.target.value;
      if (val.target.value == 1) {
        this.menuData.leafFlag = val.target.value;
      }
    },
    // 提交表单，检查必填项（方法描述）
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.menuData.url = values.url;
          this.menuData.name = values.name;
          this.menuData.icon = values.icon;
          this.menuData.component = values.component;
          if (!this.isEdit) {
            this.addPermission(this.menuData);
          } else {
            this.updatePermission(this.menuData);
          }
        }
      });
    },
    // 添加菜单
    addPermission(data) {
      let _that = this;
      data.companyStoreId = this.$store.state.shopId;
      addPermission(
        data,
        {},
        {
          companyStoreId: this.$store.state.shopId,
        }
      ).then((res) => {
        if (res.success) {
          _that.visible = false;
          _that.$emit("SuccessfullyAdded");
          _that.$message.success(res.logMessage);
        } else {
          _that.$message.error(res.logMessage);
        }
      });
    },
    // 修改菜单
    updatePermission(data) {
      let _that = this;
      data.companyStoreId = this.$store.state.shopId;
      updatePermission(
        data,
        {},
        {
          companyStoreId: this.$store.state.shopId,
        }
      ).then((res) => {
        if (res.success) {
          _that.visible = false;
          _that.$emit("SuccessfullyAdded");
          _that.$message.success(res.logMessage);
        } else {
          _that.$message.error(res.logMessage);
        }
      });
    },
    findPermissionAll() {
      let _that = this;
      var data = new FormData();
      data.append("companyStoreId", this.$store.state.shopId);
      data.append("permissionType", "3");
      findPermissionAll(data, {}, {}).then((res) => {
        if (res.success) {
          console.log(res);
        }
      });
    },
  },
  watch: {
    // 'menuData.menuType' () {
    //   if (this.menuData.menuType == '0') {
    //     this.menuData.component = 'layout/RouteView'
    //     this.setMenuData()
    //   } else {
    //     this.menuData.component = 'layout/SecondView'
    //     this.setMenuData()
    //   }
    // }
  },
};
</script>
<style lang="scss">
.new-add-menu {
  .menu-type {
    display: inline-block;
    width: 115px;
    text-align: right;
  }
}
</style>
